import {addClass} from '@opten/dom/add-class';
import {removeClass} from '@opten/dom/remove-class';
import {addTransitionEndListener} from '@opten/transition/add-transition-end-listener';

const transitionDuration = 600;

export function showMegaDropdown(
    dropdown: HTMLElement,
    backdropElement?: HTMLElement,
    callback?: () => void,
    callbackTimeout: number = 10,
) {
    if (callback) {
        addTransitionEndListener(
            dropdown,
            () =>  setTimeout(() => callback(),callbackTimeout),
            transitionDuration
        );
    }

    addClass(dropdown, '--show');

    if (backdropElement) {
        addClass(backdropElement, '--show');
    }
}

export function hideMegaDropdown(
    dropdown: HTMLElement,
    backdropElement?: HTMLElement,
    callback?: () => void
) {
    // add fade-out class for faster animations
    addClass(dropdown, '--fade-out');
    removeClass(dropdown, '--show');

    if (backdropElement) {
        // add fade-out class for faster animations
        addClass(backdropElement, '--fade-out');
        removeClass(backdropElement, '--show');
    }

    addTransitionEndListener(
        dropdown,
        () => {
            // remove fade-out so if we hover again, they're still slow
            removeClass(dropdown, '--fade-out');

            if (backdropElement) {
                // remove fade-out so if we hover again, they're still slow
                removeClass(backdropElement, '--fade-out');
            }

            if (callback) {
                callback();
            }
        },
        transitionDuration
    );
}
